import { Component, ElementRef, ViewChild } from "@angular/core";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { getFromLocalStorage, LocalStorageKey } from "@ponder-shared/utils/localStorage";
import { SvgIcon, SvgIconMap } from "@ponder-shared/utils/svgIcons";
import { Subscription } from "rxjs";

@Component({
    selector: "toggle-control-visibility",
    imports: [],
    templateUrl: "./toggle-control-visibility.component.html"
})
export class ToggleControlVisibilityComponent {
    @ViewChild("container") private containerRef!: ElementRef<HTMLDivElement>;

    public readonly visibleIcon: string = SvgIconMap.get(SvgIcon.Visible)!;
    public readonly hiddenIcon: string = SvgIconMap.get(SvgIcon.Hidden)!;

    public selfVisible: boolean = false;
    public controlsVisible: boolean = true;

    private resizeSub!: Subscription;

    public constructor(private events: EventBroker) {
        this.resizeSub = this.events.ui.windowResizeEvent.subscribe({
            next: () => {
                this.updateSelfVisibility();
            }
        });
    }

    public ngOnInit(): void {
        this.updateSelfVisibility();
    }

    public ngOnDestroy(): void {
        this.resizeSub.unsubscribe;
    }

    private updateSelfVisibility(): void {
        this.selfVisible = true;//isMobileScreen();
        this.controlsVisible = getFromLocalStorage(LocalStorageKey.PreviewItemControlsVisibility, "hidden") == "visible";

        /*
        var bounds = this.containerRef.nativeElement.getBoundingClientRect();
        var offsetX = window.innerWidth - bounds.right - 5;

        this.containerRef.nativeElement.style.setProperty("right", `${-offsetX}px`);
        */
    }

    public onClick(): void {
        this.controlsVisible = !this.controlsVisible;
        localStorage.setItem(LocalStorageKey.PreviewItemControlsVisibility, (this.controlsVisible ? "visible" : "hidden"));
        this.events.ui.previewItemControlsToggledEvent.emit();
    }
}